import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  tippingContainer: {
    backgroundColor: colors.cartBackground,
    padding: theme.spacing[2],
    borderRadius: theme.borderRadius.s,
    alignItems: 'center',

    variants: {
      inverted: {
        true: {
          backgroundColor: colors.backgroundL0,
        },
      },
      // `chips` (SQR-14766 standby order step, design-refs section 1): no
      // filled track — separate chips with their own borders, row gap 8.
      variant: {
        chips: {
          backgroundColor: 'transparent',
          padding: 0,
          gap: theme.spacing[3],
        },
      },
    },
  },
  tipItem: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: theme.spacing[3],
    borderRadius: theme.borderRadius.s,
    backgroundColor: 'transparent',

    variants: {
      selected: {
        true: {
          backgroundColor: colors.cartTipSelectedBackground,
        },
      },
      disabled: {
        true: {
          backgroundColor: colors.backgroundL3Inverse,
        },
      },
      inverted: {
        true: {},
      },
      // `flex` lives entirely per-variant (not on the base style) so neither
      // branch has to fight the other's shorthand — `segmented` (booking,
      // default) fills the track evenly; `chips` (SQR-14766 standby order
      // step) hugs content, with the Custom slot opting back into `flex: 1`
      // via the compound below.
      variant: {
        segmented: {
          flex: 1,
        },
        chips: {
          flexGrow: 0,
          flexShrink: 0,
          height: 38,
          paddingVertical: 0,
          paddingHorizontal: theme.spacing[4],
          borderWidth: 1,
          borderColor: colors.borderPrimaryAlpha,
        },
      },
      isCustomSlot: {
        true: {},
      },
      equalWidthChips: {
        true: {},
        false: {},
      },
    },
    compoundVariants: [
      {
        disabled: true,
        selected: false,
        styles: {
          backgroundColor: 'transparent',
        },
      },
      {
        inverted: true,
        selected: true,
        styles: {
          // Swap the selected background color
          backgroundColor: colors.backgroundPrimaryInverse,
        },
      },
      {
        variant: 'chips',
        selected: true,
        styles: {
          backgroundColor: colors.backgroundPrimaryInverse,
          borderWidth: 0,
        },
      },
      {
        variant: 'chips',
        isCustomSlot: true,
        styles: {
          // Same fixed height as the percentage chips (`paddingVertical: 0`
          // above) — text was clipping to ~4px tall when this also carried
          // vertical padding on top of `height: 38` (Guido QA).
          flex: 1,
          // Explicit, because on native Yoga the chips variant's flexGrow 0
          // beats the `flex` shorthand and the chip collapses to its padding.
          flexGrow: 1,
          flexShrink: 1,
          paddingHorizontal: theme.spacing[6],
        },
      },
      // Desktop presentation (design-refs): ALL FIVE chips equal-width,
      // including Custom — overrides both the content-sized percentage chips
      // above and the Custom slot's own wider horizontal padding.
      {
        variant: 'chips',
        equalWidthChips: true,
        styles: {
          flex: 1,
          flexGrow: 1,
          flexShrink: 1,
          paddingHorizontal: theme.spacing[4],
        },
      },
    ],
  },
  tipItemText: {
    color: colors.cartTextPrimary,

    variants: {
      selected: {
        true: {
          color: colors.cartTipSelectedText,
        },
      },
      inverted: {
        true: {
          color: colors.textPrimary,
        },
      },
      variant: {
        chips: {
          color: colors.textPrimary,
        },
      },
    },
    compoundVariants: [
      {
        inverted: true,
        selected: true,
        styles: {
          // Swap the text color when inverted and selected
          color: colors.textPrimaryInverse,
        },
      },
      {
        variant: 'chips',
        selected: true,
        styles: {
          color: colors.textPrimaryInverse,
        },
      },
    ],
  },

  otherTipInput: {
    backgroundColor: colors.cartBackground,
    paddingVertical: theme.spacing[2],
    paddingHorizontal: theme.spacing[4],

    variants: {
      inverted: {
        true: {
          backgroundColor: colors.backgroundL0,
        },
      },
    },
  },
  confirmOtherTipButton: {
    backgroundColor: colors.cartTipSelectedBackground,

    variants: {
      inverted: {
        true: {
          backgroundColor: colors.backgroundPrimaryInverse,
        },
      },
    },
  },
  otherTipInputText: {
    color: colors.cartTextPrimary,
    fontWeight: '600',

    variants: {
      inverted: {
        true: {
          color: colors.textPrimary,
        },
      },
    },
  },
}));
